import ClearIcon from "@mui/icons-material/Clear";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import { Box, InputAdornment, styled } from "@mui/material";
import React, { useContext, useState } from "react";
import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import { MemoizedNameField } from "../../../SDK/input/nameInput";
import { myScroll } from "../../../utils/myScroll";
import { sendAnalytics } from "../../../utils/analyticsCommon";
const CustomSearchBar = styled(Box)(({ theme }) => ({
  width: "100%",
  outline: "none",
  overflow: "hidden",
  border: "none !important",
  ".text-input": {
    borderRadius: "40px",
    border: "none !important",
    width: "100%",
    borderRadius: "30px",
    outline: "none !important",
    "&focus": {
      outline: "none !important",
    },
    background: "white",
    boxShadow: "0px 4px 10px 0px #0000001A",
  },
  //need to target the input field to get the desired rounded search fiels without outer border
  ".text-input .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl":
    {
      border: "none !important",
      borderRadius: "100px",
      outline: "none !important",
    },
}));
const SearchBar = () => {
  const { searchQuery } = useContext(Context);
  const [query, setQuery] = useState("");

  const showSearchQueryResults = () => {
    let payload = {
      searched_value: query,
    };
    sendAnalytics("search_an_vehicle", payload, "en");
    searchQuery(query);
    myScroll(
      0,
      document.getElementById("search-result").offsetTop + 100,
      "smooth"
    );
  };

  return (
    <CustomSearchBar>
      <Box>
        <MemoizedNameField
          type={"text"}
          style={{ border: "none !important", outline: "none !important" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {query?.length !== 0 ? (
                  <ClearIcon
                    onClick={() => {
                      searchQuery("");
                      setQuery("");
                    }}
                    style={{
                      color: primary.main,
                      cursor: "pointer",
                      marginRight: "4px",
                    }}
                  />
                ) : (
                  <SearchTwoToneIcon
                    style={{ color: primary.greyText, cursor: "pointer" }}
                  />
                )}

                {query?.length > 0 && (
                  <SearchTwoToneIcon
                    style={{ color: primary.darkGreen, cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      showSearchQueryResults();
                    }}
                  />
                )}
              </InputAdornment>
            ),
          }}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e?.key === "Enter") {
              showSearchQueryResults();
            }
          }}
          value={query}
          placeholder="Search by model, brand etc."
          className="text-input"
        />
      </Box>
    </CustomSearchBar>
  );
};

const MemoizedSearchInput = React.memo(SearchBar);
export default MemoizedSearchInput;
